// ##############################
// // // LoginPage view styles
// #############################

//import { container } from 'assets/styles/jss/main'

const loginPageStyle = {
  content: {
    position: 'relative',
    zIndex: '4',
    minHeight: '100vh',
    paddingTop: 80,
    display: 'flex',
    alignItems: 'center',
  },
  customButtonClass: {
    '&,&:focus,&:hover': {
      color: '#FFFFFF',
    },
    marginLeft: '5px',
    marginRight: '5px',
  },
  inputAdornment: {
    marginRight: '18px',
  },
  inputAdornmentIcon: {
    color: '#555',
  },
  inputLabelIcon: {
    color: '#555',
    verticalAlign: '-18px',
  },
  card: {
    animation: 'slide-down 0.5s',
  },
  socialButton: {
    minWidth: 'auto',
    minHeight: 'auto',
    color: '#FFFFFF',
    boxShadow:
      '0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)',
    border: 'none',
    borderRadius: '4px',
    position: 'relative',
    padding: '10px 30px',
    margin: '10px 1px',
    fontSize: '14px',
    fontWeight: '400',
    textTransform: 'uppercase',
    letterSpacing: '0',
    willChange: 'box-shadow, transform',
    transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    lineHeight: '1.3',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    '&:hover': {
      boxShadow:
        '0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)',
    },
    //full width
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
    '& .fab': {
      position: 'absolute',
      left: 14,
    },
  },
  google: {
    backgroundColor: '#dd4b39',
    color: '#fff',
    '& .fa-google': {
      backgroundColor: '#fff',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent !important',
    },
  },
  socialButtonIcons: {
    fontSize: '18px',
    marginTop: '-2px',
    position: 'relative',
  },
  marginRight5: {
    marginRight: '5px',
  },
  marginRight10: {
    marginRight: '10px',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 200,
  },
  buttonFlat: {
    margin: '5px 0 0',
    padding: 0,
    fontWeight: 400,
    textTransform: 'initial',
  },
  buttonFooter: {
    padding: '12px 10px',
  },
};

export default loginPageStyle;
